import { render, staticRenderFns } from "./FxExchangeRatesBiz.vue?vue&type=template&id=467f990f&scoped=true"
import script from "./FxExchangeRatesBiz.vue?vue&type=script&lang=js"
export * from "./FxExchangeRatesBiz.vue?vue&type=script&lang=js"
import style0 from "./FxExchangeRatesBiz.vue?vue&type=style&index=0&id=467f990f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467f990f",
  null
  
)

export default component.exports